<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-row>
                    <v-col cols="4">
                        <h3 class="pl-3">{{ $t('upload.table.dateiname') }}</h3>
                    </v-col>
                    <v-col cols="1">
                        <h3>{{ $t('upload.table.groesse') }}</h3>
                    </v-col>
                    <v-col cols="3">
                        <h3>{{ $t('upload.table.typ') }}</h3>
                    </v-col>
                    <v-col cols="4">
                        <h3>{{ $t('upload.table.schlagworte') }}</h3>
                    </v-col>
                </v-row>
                <div v-for="(row, index) in uploadFiles" :key="index">
                    <UploadRow :upload-file="row" :typen="dokumentTypen" @remove="removeFile" />
                </div>
                <v-card>
                    <v-row>
                        <v-col cols="4" class="pa-5">
                            <!-- ShowFileList ist false da sie hier selbst erstellt wird -->
                            <!-- instantupload true, da fileliste extern verwaltet wird -->
                            <UploadPanel
                                id="uploadZone"
                                :show-filelist="false"
                                :multiple="true"
                                :instant-upload="true"
                                class="pl-3"
                                @update:model-value="saveFileInArrayDropzone"
                            >
                                <template #button><VEmpty /></template>
                            </UploadPanel>
                        </v-col>
                        <v-col cols="1" />
                        <v-col cols="3">
                            <v-select v-model="setDokumentTyp" class="mt-5" :items="dokumentTypen" dense hide-details></v-select>
                        </v-col>
                        <v-col cols="4">
                            <v-combobox
                                ref="combobox"
                                v-model="selectedSchlagworte"
                                v-model:search="schlagwortSearchString"
                                :items="schlagwortSelection"
                                :label="$t('upload.table.schlagworte')"
                                :hide-no-data="!schlagwortSearchString"
                                bg-color="white"
                                class="mt-3"
                                append-icon=""
                                multiple
                                :clear-on-select="true"
                                :hide-selected="true"
                                :custom-filter="customFilter"
                                @keydown.space.prevent="simulateEnter"
                            >
                                <template #selection="{ attrs, item, selected, index }">
                                    <v-chip
                                        v-bind="attrs"
                                        :input-value="selected"
                                        label
                                        small
                                        closable
                                        @click:close="deleteSchlagwortFromSelection(index, item.raw)"
                                    >
                                        <span class="pr-2">
                                            {{ item.value }}
                                        </span>
                                    </v-chip>
                                </template>
                                <template #item="{ props, item, index }">
                                    <v-list-item v-if="item.raw.header && search">
                                        <span class="mr-3">Create</span>
                                        <v-chip size="small" variant="flat" label>
                                            {{ search }}
                                        </v-chip>
                                    </v-list-item>
                                    <v-list-subheader v-else-if="item.raw.header" :title="item.title"></v-list-subheader>
                                    <v-list-item v-else @click="props.onClick">
                                        <v-chip :text="item.raw" variant="outlined"></v-chip>
                                        <template #append>
                                            <v-btn
                                                icon="mdi-delete"
                                                size="small"
                                                variant="text"
                                                @click.stop.prevent="deleteSchlagwortFromDatabase(index, item.raw)"
                                            ></v-btn>
                                        </template>
                                    </v-list-item>
                                </template>
                            </v-combobox>
                        </v-col>
                    </v-row>
                </v-card>
                <input id="fileUpload" type="file" multiple hidden @change="saveFileInArrayButton" />
                <v-row class="mt-5">
                    <v-col sm="2 pt-0 pb-5">
                        <v-btn v-if="uploadFiles.length < 1" large color="primary" @click="chooseFiles()">{{ $t('upload.button.auswaehlen') }}</v-btn>
                        <v-btn v-else large color="primary" @click="uploadDokumenteWrapper"> {{ $t('upload.button.confirm') }}</v-btn>
                    </v-col>
                    <v-col sm="8 pt-0 pb-5">
                        <i>{{ $t('upload.remarks') }}</i> <br />
                        <i>{{ allowedFileTypes.join(', ') }}</i>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<script lang="ts">
import { Component, Vue, Watch } from 'vue-facing-decorator';
import { namespace } from 'vuex-facing-decorator';
import debounce from 'lodash/debounce';

import { NAME as NAME_UPLOAD } from '../store';
import { NAME as NAME_GENERAL } from '@/store/modules/general';
import { NAME as NAME_HEADER } from '@/store/modules/headerNotification';
import { NAME as NAME_SECURITY } from '@/store/modules/security';
import { NAME as NAME_RESOURCE } from '@/store/modules/resource';

const uploadModul = namespace(NAME_UPLOAD);
const generalModul = namespace(NAME_GENERAL);
const headerModul = namespace(NAME_HEADER);
const securityModul = namespace(NAME_SECURITY);
const resourceModul = namespace(NAME_RESOURCE);

import { GET_LANGUAGE } from '@/store/modules/resource/getters';
import { HASACCESS } from '@/store/modules/security/getters';
import { SETACCESSDENIED } from '@/store/modules/security/mutations';
import { SUBTITLE, FOOTERTITLE } from '@/store/modules/general/mutations';
import { GET_DOKUMENT_TYPEN, UPLOAD_DOKUMENT, UPLOAD_DOKUMENTE, GET_SCHLAGWORTE, CREATE_SCHLAGWORT, DELETE_SCHLAGWORT } from '../store/actions';
import { DOKUMENTTYPEN, SCHLAGWORTVORSCHLAEGE } from '../store/getters';
import { NEW_ERRORMESSAGES, CLOSE } from '@/store/modules/headerNotification/actions';

import { NAME as NAME_VALIDATION } from '@/store/modules/validation';
const validationModul = namespace(NAME_VALIDATION);
import { GET_ALLOWED_FILETYPES } from '@/store/modules/validation/getters';

import UploadRow from './UploadRow.vue';
import UploadPanel from '@/components/UploadPanel.vue';
import { DokumentUploadDto } from '@/types/DokumentUploadDto';
import VEmpty from '@/components/VEmpty.vue';
import { i18n } from '@/plugins/i18n';
@Component({
    components: {
        UploadRow,
        UploadPanel,
        VEmpty
    }
})
export default class DokumentUpload extends Vue {
    @generalModul.Mutation(SUBTITLE) setSubTitle!: Function;
    @generalModul.Mutation(FOOTERTITLE) setFooterTitle!: Function;

    @uploadModul.Action(GET_DOKUMENT_TYPEN) getDokumentTypen!: Function;
    @uploadModul.Action(UPLOAD_DOKUMENT) uploadDokument!: Function;
    @uploadModul.Action(UPLOAD_DOKUMENTE) uploadDokumente!: Function;
    @uploadModul.Action(GET_SCHLAGWORTE) getSchlagworte!: Function;
    @uploadModul.Action(CREATE_SCHLAGWORT) createSchlagwort!: Function;
    @uploadModul.Action(DELETE_SCHLAGWORT) deleteSchlagwort!: Function;
    @uploadModul.Getter(DOKUMENTTYPEN) dokumentTypen!: Array<object>;
    @uploadModul.Getter(SCHLAGWORTVORSCHLAEGE)
    schlagwortSelection!: Array<string>;

    @headerModul.Action(NEW_ERRORMESSAGES) alertMessage!: Function;
    @headerModul.Action(CLOSE) closeHeadermessage!: Function;

    @securityModul.Getter(HASACCESS) hasAccess!: Function;
    @securityModul.Mutation(SETACCESSDENIED) setAccessDenied!: Function;
    @resourceModul.Getter(GET_LANGUAGE) language!: string;

    @validationModul.Getter(GET_ALLOWED_FILETYPES)
    allowedFileTypes!: Array<string>;

    uploadFiles: Array<DokumentUploadDto> = [];
    setDokumentTyp = 'archiv.dokumenttyp.eigenesdok';
    setSchlagworte = '';

    schlagwortSearchString = '';
    schlagwortEditText = '';
    selectedSchlagworte = [];

    created() {
        this.setSubTitle(this.$t('upload.title'));
        this.setFooterTitle('S310');
    }

    mounted() {
        if (!this.hasAccess('Navigation.Dokumentupload')) {
            this.setAccessDenied(true);
            this.alertMessage({ text: this.$t('errormessage.noaccesspage') });
        } else {
            this.setAccessDenied(false);
            this.getDokumentTypen();
        }
    }

    get sizeOfAllFilesTooLarge() {
        const sizeOfAllFiles = this.uploadFiles.map((doc) => doc.datei.size).reduce((a, b) => a + b);
        return sizeOfAllFiles > 52428800 * 4;
    }

    uploadDokumenteWrapper() {
        this.closeHeadermessage();

        if (this.sizeOfAllFilesTooLarge) {
            this.alertMessage({
                errorMessages: i18n.global.t('upload.errormessage.maxuploadlimit')
            });
        } else {
            this.uploadDokumente(this.uploadFiles);
        }
    }

    chooseFiles() {
        const element = document.getElementById('fileUpload');
        if (element !== null) {
            element.click();
        }
    }

    saveFileInArrayButton() {
        const element = document.getElementById('fileUpload') as HTMLInputElement;
        if (element.files !== null) {
            this.saveFileInArrayDropzone(Array.from(element.files));
            element.files = null;
        }
    }

    saveFileInArrayDropzone(files: Array<File>) {
        console.log('saving file');
        this.closeHeadermessage();
        if (files.some((file) => file.size > 52428800)) {
            const wrongSizeFiles = files.filter((file) => file.size > 52428800);
            this.alertMessage({
                errorMessages: i18n.global.t('upload.errormessage.maxfilesize') + ' ' + wrongSizeFiles.map((file) => file.name).join(', ')
            });
        } else if (files.some((file) => !this.checkFileType(file))) {
            const wrongTypeFiles = files.filter((file) => !this.checkFileType(file));
            this.alertMessage({
                errorMessages: i18n.global.t('errormessage.dokument.typ', [wrongTypeFiles.map((file) => this.getFileType(file)).join(', ')])
            });
        } else {
            files.forEach((file) => {
                const temp = new DokumentUploadDto(file);
                temp.dokumentTyp = this.setDokumentTyp;
                temp.schlagworte = this.setSchlagworte;
                temp.schlagwortVorschlaege = this.selectedSchlagworte;
                this.uploadFiles.push(temp);
            });
        }
        this.setDokumentTyp = 'archiv.dokumenttyp.eigenesdok';
        this.setSchlagworte = '';
        this.selectedSchlagworte = [];
    }
    getFileType(file: File) {
        return file.name.split('.').pop();
    }
    checkFileType(file: File) {
        let isacceptedFileType = false;
        const fileType = this.getFileType(file);

        this.allowedFileTypes.forEach(function (element) {
            const acceptFileType = element.replace('.', '');

            if (fileType && acceptFileType.toLowerCase() === fileType.toLowerCase()) {
                isacceptedFileType = true;
            }
        });
        return isacceptedFileType;
    }

    removeFile(uuid: string) {
        this.uploadFiles = this.uploadFiles.filter((file: DokumentUploadDto) => {
            return file.uuid !== uuid;
        });
    }

    simulateEnter(event: Event) {
        // Hack, damit bei 'Space' der gleiche Event ausgelöst wird wie bei 'Enter'.
        // Grund: Der Suchstring kann nicht manuell zurückgesetzt werden
        event.preventDefault();
        const enterEvent = new KeyboardEvent('keydown', {
            key: 'Enter',
            code: 'Enter',
            keyCode: 13,
            bubbles: true
        });

        event.target.dispatchEvent(enterEvent);
    }

    deleteSchlagwortFromSelection(index, item) {
        if (index > -1) {
            this.schlagwortSelection.splice(index, 1);
            this.selectedSchlagworte.splice(index, 1);
        }
    }
    deleteSchlagwortFromDatabase(index, item) {
        this.deleteSchlagwort(item);
        this.getSchlagworte(this.schlagwortSearchString);
    }

    @Watch('language')
    onLanugageChanged() {
        this.getDokumentTypen();
    }

    @Watch('selectedSchlagworte')
    onSelectedSchlagworteChanged(newVal: any, oldVal: any) {
        this.setSchlagworte = this.selectedSchlagworte.join(' ');
        if (newVal.length === oldVal.length || newVal.length < oldVal.length) {
            return;
        }

        // Get the new value that was added
        const newEntry = newVal[newVal.length - 1];
        // Suchstrings mit wildcards werden nur für suche verwendet, aber nie als schlagwort erstellt
        if (typeof newEntry === 'string' && newEntry.includes('*')) {
            this.selectedSchlagworte.pop();
            return;
        }

        if (this.schlagwortSelection.includes(newVal[newVal.length - 1])) {
            return;
        }
        //Dieser Teil wird nur Ausgeführt wenn ein neues Schlagwort hinzugefügt wird.
        if (newVal[newVal.length - 1] != undefined) {
            this.createSchlagwort(newVal[newVal.length - 1]);
        }
    }

    @Watch('schlagwortSearchString')
    onSearchStringChanged() {
        this.bouncedSearchStringChange();
    }

    private bouncedSearchStringChange = debounce(function (this: DokumentUpload) {
        if (this.schlagwortSearchString != null) {
            if (this.schlagwortSearchString.trim() != '') {
                this.getSchlagworte(this.schlagwortSearchString);
            }
        }
    }, 400);

    customFilter(item: string, queryText: string): boolean {
        // Ersetze "*" mit dem Regex-Platzhalter-Muster
        const searchText = queryText.replace(/\*/g, '.*');
        // Erstelle ein Regex-Muster und entferne Sonderzeichen ausser "*"
        const regex = new RegExp(searchText.replace(/[-/\\^$+?.()|[\]{}]/g, '\\$&'), 'i');
        return regex.test(item);
    }
}
</script>
